export default {
  "component": {
    "tradeInProcess": {
      "649f8aefats0": "Ordren er udløbet",
      "649f8aefc1c0": "Genbrug mislykkedes",
      "649f8aefc9c0": "Få et nyt tilbud",
      "TradeIn": "Trade-In-proces",
      "logistic": "Download fragtetiketten",
      "start": "Start processen",
      "success": "Du har modtaget din nye enhed",
      "qc": "Kvalitetskontrol af din gamle enhed",
      "business": "Vi afslutter inspektionen af din gamle enhed inden for 3 arbejdsdage",
      "completed": "Fuldført",
      "successfully": "Tillykke, dit Trade-In er gennemført med succes",
      "orderInfor": "Ordreoplysninger",
      "orderID": "Trade-In-ordre-ID",
      "orderNum": "Købsordre-ID for ny enhed",
      "createTime": "Oprettelsestidspunkt",
      "brand": "Forventet mærke",
      "model": "Forventet model",
      "price": "Værdi af din gamle enhed",
      "bonus": "Bonus",
      "reclaimFailure": "Da din enhed ikke blev sendt inden for 10 dage, er genbrugsordren udløbet og blevet annulleret. Hvis du stadig ønsker at fuldføre genbruget, kan du klikke på knappen nedenfor for at få et nyt tilbud.",
      "total": "Samlet pris",
      "logisticInfo": "Forsendelsesoplysninger",
      "available": "Ingen forsendelsesoplysninger tilgængelige",
      "logisticNum": "Forsendelsesnummer",
      "failRey": "Vi beklager, at din deltagelse i OnePlus-genbrugsprogrammet ikke blev gennemført. Hvis du planlægger at genbruge andre elektroniske produkter, kan du klikke på knappen nedenfor for et hurtigt estimat!",
      "userRes": "Brugeren har allerede afvist tilbuddet.",
      "successPrice": "Prisen herunder er fastsat efter professionel vurdering. Hvis du accepterer, fortsætter vi med Trade-In. Hvis du afviser, sender vi enheden tilbage inden for få arbejdsdage.",
      "sure": "Accepter",
      "Reject": "Afvis",
      "congratulation": "Tillykke, din enhed bestod kvalitetskontrollen uden afvigelser.",
      "finPirce": "Endelig pris",
      "copySuccess": "Kopiering lykkedes",
      "copyfail": "Kopiering mislykkedes",
      "sureSuccess": "Bekræft vellykket transaktion",
      "submitError": "Indsendelse mislykkedes",
      "detectionResult": "Inspektionsresultat",
      "Collected": "Afgiv en ordre",
      "inTransit": "Under transport",
      "656g0lj3sav6": "Genbrugsproces",
      "656g0lj3cd5a": "Udfyld dine personlige oplysninger korrekt for at afgive ordren.",
      "656g0lj3dr9a": "Inspektionen af din telefon færdiggøres inden for 48 timer efter ankomst til vores center.",
      "656g0lj3epal": "Når inspektionen er afsluttet, kontakter vi dig via e-mail med det endelige tilbud.",
      "656g0lj3pda2": "Dit estimat",
      "656g0lj3ed3d": "Professionel kvalitetskontrol",
      "656g0lj3esf3": "Kopiér",
      "expertDiscount": "Kampagnekode",
      "invalidCode": "Ugyldig kode",
      "toastTip": "Marker for at acceptere privatlivspolitik og vilkår.",
      "649f8aef26sf": "Trade-In-proces",
      "checkTitle": "Testinformation",
      "basicInformation": "Grundlæggende oplysninger",
      "understand": "Jeg forstår"
    },
    "btnDialog": {
      "64a9shqq2ks0": "Afvis genbrug",
      "64a9shqq3k00": "Du bekræfter, at du afviser at genbruge",
      "64a9shqq3r00": "Annullering gennemført",
      "64a9shqq3ws0": "Annullering mislykkedes",
      "sureCancel": "Bekræft annullering"
    }
  },

  "home": {
    "whoAreWe": {
      "646u995ltgw0": "Hvem",
      "646u995lv9g0": "er vi?",
      "646u9d5lv9g0": "Danghuan er en virksomhed, der har sit kerneområde inden for genbrug, håndtering og salg af 3C-digitale produkter som mobiltelefoner, tablets, bærbare computere og smartwatches. Vores virksomhed arbejder målrettet på at øge effektiviteten af elektronisk genbrug og fremme en bæredygtig udvikling af markedet for brugte enheder. Vi har i øjeblikket etableret officielle strategiske partnerskaber med OPPO, Vivo, OnePlus, Realme og flere andre. Vores internationale forretning har udvidet sig til Indien, Thailand, Vietnam, Cambodja og nu også Europa.",
      "646u995dv9g0": "Vores globale tilstedeværelse har gjort os til en strategisk partner for mobiloperatører, producenter og grossister – både på nationalt og internationalt plan.",
      "646u99slv9g0": "Vi samarbejder med førende producenter og opretholder et bredt sortiment, der dækker både lav-, mellem- og high-end enheder. Det gør det muligt for os at tilbyde skræddersyede løsninger og konkurrencedygtige priser, der imødekommer vores kunders behov."
    },
    "business": {
      "646v04syvpk0": "Er du interesseret i at købe vores lagerprodukter?",
      "646v04syxs80": "Hos Danghuan tilbyder vi et omfattende udvalg af mobiltelefoner, tablets og smartwatches i forskellige kvalitetsklasser for at imødekomme forskellige forretningsbehov.",
      "646v04syy6g0": "Kontakt vores salgs- og indkøbschef:",
      "646v04syya80": "Jeg vil gerne købe",
      "646v04syydg0": "Indtast dit navn",
      "646v04syyh40": "Indtast dit telefonnummer",
      "646v04syyyw0": "Indtast din e-mailadresse",
      "646v0gsyz1s0": "Land:",
      "646v04syz1s0": "Vælg venligst en mulighed",
      "646v04syz4o0": "Jeg har læst og accepterer",
      "646v04syzkc0": "Privatlivspolitik",
      "646v04syzok0": "Kontakt os",
      "646v04syzvo0": "Indtast venligst dit telefonnummer",
      "646v04syzys0": "Indtast venligst din e-mail",
      "646v04sz01o0": "Indtast venligst en gyldig e-mailadresse",
      "646v04sz04g0": "Indtast venligst dit navn",
      "646v04sz0740": "Marker afkrydsningsfeltet for at acceptere privatlivspolitikken",
      "646v04sz0a00": "Indsendelse lykkedes",
      "646v04sz0cw0": "Indsendelse mislykkedes",
      "title1": "Gennemsigtig kvalitetsvurdering af mobiltelefoner",
      "text1-1": "For at støtte dine købsbeslutninger opfordrer vi dig til at gennemgå vores detaljerede vurderingsdokument. Dokumentet beskriver de æstetiske og funktionelle standarder for hver kategori, så du kan træffe velinformerede valg, der matcher dine forventninger.",
      "title2": "Engagement i bæredygtig teknologi",
      "text2-1": "Vi anerkender, at hver kunde har unikke behov. Derfor er vores team af flersprogede salgseksperter dedikeret til at levere skræddersyet og professionel support.",
      "title3": "Engagement i bæredygtig teknologi",
      "text3-1": "Vi arbejder for at fremme global adgang til bæredygtige teknologiløsninger og sikre, at vores processer skaber værdi for alle involverede parter.",
      "text3-2": "For yderligere forespørgsler eller for at arrangere en prøveordre, kontakt os venligst."
    }
  },
  "components": {
    "section2": {
      "646tj9dnkk00": "Få din betaling hurtigt i kun 4 trin",
      "s1": "Trin ét",
      "s1t": "Pak din enhed omhyggeligt, så den ankommer i samme stand som den blev sendt.",
      "s2": "Trin to",
      "s2t": "Aflever din pakke på et af vores afleveringssteder.",
      "s3": "Trin tre",
      "s3t": "Lad os inspicere din enhed og give dig et tilbud.",
      "s4": "Trin fire",
      "s4t": "Få din betaling hurtigt."
    },
    "section3": {
      "646tmse2fbo0": "Smartphones",
      "646tmse2mv00": "Hold dig opdateret",
      "section3-text2": "Tablets",
      "section3-text4": "Ure",
      "section3-text5": "Andre",
      "title": "Hurtig vurdering",
      "t1": "Vælg typen og start vurderingen – få et retfærdigt tilbud.",
      "t2": "Enkle trin – nyd vores hurtige genbrugstjeneste!"
    },
    "section6": {
      "646txzpazuc0": "Om Danghuan",
      "666txzpazuc0": "Et firma, der specialiserer sig i genbrug og genanvendelse af smartphones, tablets og andre digitale enheder – dedikeret til at levere en enkel, sikker og effektiv service, så alle kunder nemt kan genbruge deres enheder.",
      "646txzpb0rk0": "Detaljer",
      "646txzpb0xc0": "Tilbyder genbrug for 12 mærker"
    },
    "section7": {
      "646ns2k5f7k0": "Vores service er altid tilgængelig",
      "646ns2k5gmw0": "Kundeservice: Mandag til fredag fra kl. 9.00 til 18.00 CET (UTC+1:00), Madrid, Spanien",
      "646ns2k5gs40": "Indtast dit navn",
      "646ns2k5gx40": "Indtast dit telefonnummer",
      "646ns2k5img0": "Indtast din e-mailadresse",
      "646ns2k5isw0": "Skriv en besked til os, før vi kontakter dig",
      "646ns2k5iws0": "Kontakt os",
      "646ns2k5j140": "Indtast venligst dit telefonnummer",
      "646ns2k5j4g0": "Indtast venligst din e-mailadresse",
      "646ds2k5j4g0": "E-Mail",
      "646ns2k5j6c0": "Indtast venligst en gyldig e-mailadresse",
      "646ns2k5j8g0": "Kontakt os",
      "646ns2k5jak0": "CVR-nr.:",
      "646ns2k5jck0": "Adresse",
      "646ns2s5jck0": "Calle del Hierro, 33, Planta 1 Nave 2, 28045 Madrid, Spanien",
      "646ns2k5jgc0": "Indtast venligst dit navn",
      "646ns2k5ji40": "Marker venligst feltet for at acceptere privatlivspolitikken",
      "646ns2k5jk00": "Indsendelse lykkedes",
      "646ns2k5jm80": "Indsendelse mislykkedes",
      "646ny1rgz3c0": "Jeg har læst og accepteret ",
      "646ny1rh2k40": "Privatlivspolitikken"
    },
    "successMain": {
      "647qmd42l1s0": "Ordren er modtaget med succes!",
      "647qmd42mss0": "Vær opmærksom på forsendelsesinstruktionen, som er sendt til dig fra no-reply@danghuan.eu. Hvis du ikke har modtaget e-mailen, skal du tjekke din spam-mappe eller kontakte vores kundeservice på insta360@danghuan.eu",
      "647qmd42mz80": "Vores tilbud",
      "647qmd42yeo0": "Tips før afsendelse",
      "orderTime": "Ordretidspunkt",
      "text1": "Gratis forsendelse",
      "text2": "Vær opmærksom på forsendelsesdokumentet, der er sendt til din e-mail.",
      "text3": "Sikkerhedskopiering af data",
      "text4": "For at beskytte dine data, lav venligst en sikkerhedskopi og slet alle data eller nulstil enheden.",
      "text5": "Opladning",
      "text6": "Sørg for, at din telefon har mindst 1% strøm, før du sender den, så inspektionen kan gennemføres hurtigere.",
      "downloadDec": "Download venligst integritetserklæringen."
    },
    "tradeInProcess": {
      "649f8aefats0": "Ordren er udløbet",
      "649f8aefc1c0": "Genbrug mislykkedes",
      "649f8aefc9c0": "Få et nyt tilbud",
      "TradeIn": "Trade-In-proces",
      "logistic": "Download fragtetiketten",
      "start": "Start processen",
      "success": "Du har modtaget din nye enhed",
      "qc": "Kvalitetskontrol af din gamle enhed",
      "business": "Vi afslutter inspektionen af din gamle enhed inden for 3 arbejdsdage",
      "completed": "Fuldført",
      "successfully": "Tillykke, dit Trade-In er gennemført med succes",
      "orderInfor": "Ordreoplysninger",
      "orderID": "Genbrugsordrenummer",
      "orderNum": "Købsordre-ID for ny enhed",
      "createTime": "Oprettelsestidspunkt",
      "brand": "Forventet mærke",
      "model": "model",
      "price": "Værdi af din gamle enhed",
      "bonus": "Bonus",
      "total": "Samlet pris",
      "logisticInfo": "Forsendelsesoplysninger",
      "available": "Ingen forsendelsesoplysninger tilgængelige",
      "logisticNum": "Forsendelsesnummer",
      "failRey": "Vi beklager, at din deltagelse i OnePlus-genbrugsprogrammet ikke blev gennemført. Hvis du planlægger at genbruge andre elektroniske produkter, kan du klikke på knappen nedenfor for et hurtigt estimat!",
      "userRes": "Brugeren har allerede afvist tilbuddet.",
      "successPrice": "Prisen herunder er fastsat efter professionel vurdering. Hvis du accepterer, fortsætter vi med Trade-In. Hvis du afviser, sender vi enheden tilbage inden for få arbejdsdage.",
      "sure": "Accepter",
      "Reject": "Afvis",
      "congratulation": "Tillykke, din enhed bestod kvalitetskontrollen uden afvigelser.",
      "finPirce": "Endelig pris",
      "copySuccess": "Kopiering lykkedes",
      "copyfail": "Kopiering mislykkedes",
      "sureSuccess": "Bekræft vellykket transaktion",
      "submitError": "Indsendelse mislykkedes",
      "detectionResult": "Inspektionsresultat",
      "Collected": "Indsamlet",
      "inTransit": "Under transport / Forsendelse",
      "understand": "Jeg forstår",
      '656g0lj3sf6e': 'De kampagnebonusser tilbydes og administreres af de tilknyttede mærker. De udbetales separat og er ikke en del af vurderingen af den gamle enhed.'
    },
    "btnDialog": {
      "64a9shqq2ks0": "Afvis genbrug",
      "64a9shqq3k00": "Du bekræfter, at du afviser at genbruge",
      "64a9shqq3r00": "Annullering gennemført",
      "64a9shqq3ws0": "Annullering mislykkedes",
      "sureCancel": "Bekræft annullering"
    }
  },
  "shippingLable": {
    "shippingLable": {
      "firstStep": "Personlige oplysninger",
      "649fhwp9zbo0": "Upload et klart billede af din pakke",
      "649fhwpa1900": "Download fragtetiketten",
      "649fhwpa1l00": "Download fragtetiketten",
      "649fhwpa1tc0": "Gennemfør levering",
      "649fhwpa2100": "Pakke-foto og Ærlighedserklæring",
      "649fhwpa2880": "Eksempel på, hvordan fragtetiketten placeres",
      "649fhwpa2h80": "Bemærk",
      "649fhwpa2qk0": "Emballage: Pak telefonen ind i bobleplast og fyld æsken med avispapir for at undgå skader under transporten.",
      "649fhwpa2xs0": "Fyld eventuelle mellemrum med beskyttende materiale for at undgå skader.",
      "649fhwpa3fk0": "Forsendelsesetiket: Medbring den digitale eller printede etiket til afleveringsstedet; den officielle etiket bliver printet der.",
      "649fhwpa3v40": "Send venligst din brugte telefon hurtigst muligt. Hvis den ikke sendes inden for 10 dage, annulleres ordren automatisk.",
      "649fhwpa42s0": "Find afleveringssted",
      "649fhwpa4as0": "Download etiketten",
      "649fhwpa4jo0": "Upload",
      "649fhwpa4ok0": "Hjem",
      "649fhwpa4to0": "Indsendelse lykkedes",
      "649fhwpa4yk0": "Tillykke, download lykkedes!",
      "649fhwpasf3s": "Bemærk",
      "649fhwpaa6f3": "Print og underskriv venligst Ærlighedserklæringen, tag derefter et billede af den sammen med pakken og upload det."
    }
  },
  "bottom": {
    "index": {
      "646d51qugz40": "Sociale medier",
      "646d71qugz40": "Nem betaling",
      "646u51qugz40": "Logistik",
      "646u5dqui780": "Privatlivspolitik",
      "646uddqui780": "Vilkår og betingelser",
      "646u51qui780": "Ofte stillede spørgsmål"
    }
  },
  "head": {
    "index": {
      "646nt7hwh0c0": "Om Danghuan",
      "646ntjwmn580": "Forretning",
      "646nt7hwils0": "Kontakt os",
      "646nt7hwipg0": "Køb",
      "646nt7hwis00": "Sælg"
    }
  },
  "PCModelList": {
    "index": {
      "646wfv5g0ro0": "Gratis vurdering"
    }
  },
  "PCSearch": {
    "index": {
      "646wgb1ni8k0": "Indtast modellen, du vil sælge",
      "646wgb1nj8o0": "搜索词",
      "646wgb1nji80": "我触发搜索上拉了",
      "empty": "Beklager, modellen findes ikke",
      "confirm": "Bekræft",
      "cancle": "Annuller",
      "dialogText": "Er du sikker på, at du vil slette hele historikken poster?"
    }
  },
  "PCProduct": {
    "empty": "Beklager, modellen findes ikke"
  },
  "PCBrandTab": {
    "index": "Mærke"
  },
  "PCCategoryTab": {
    "index": "Kategori"
  },
  "PCOrderStep": {
    "index": {
      "646xagqwff40": "Bestil online",
      "646xagqwkuw0": "Gratis forsendelse",
      "646xagqwmao0": "Testning",
      "646xagqwmlc0": "Hurtig betaling"
    }
  },
  "PCBreadNav": {
    "index": {
      "646xgup6ugg0": "Hjem"
    }
  },
  "router": {
    "selectModel": "Modeller",
    "selectProperty": "Enhedsproblemer",
    "price": "Anslået pris",
    "priceOrder": "Afgiv en ordre",
    "orderSuccess": "Ordre afgivet med succes"
  },
  "PCDeviceInfo": {
    "index": {
      "646ymq6orm00": "Vælg model igen",
      "646ymq6ot0k0": "Påmindelse",
      "646ymq6pd100": "Sørg for at logge ud af din sky-konto før afsendelse",
      "646ymq6pekw0": "/skærmlås/Apple ID på den gamle enhed."
    }
  },
  "PCModelInfo": {
    "index": {
      "646yn085ljk0": "Vælg enhedens tilstand",
      "647h1f4yr6c0": "Anslået pris",
      "647h1f4yso80": "Anslået bonus",
      "text1": "Gratis forsendelse",
      "text2": "Vi tilbyder gratis logistik og forsendelse",
      "text3": "Øjeblikkelig betaling",
      "text4": "Vi overfører betalingen inden for 3 hverdage, efter vi har modtaget din brugte enhed.",
      "64tve23zt0g0": "Gratis forsendelse og salgspakke",
      "64tve23zup00": "Sikker sletning af data",
      "64tve23zuy40": "Ikke tilfreds? Gratis returnering",
      "64tve23zv7g0": "Betalingen behandles inden for 3 hverdage efter modtagelsen.",
      "64tve23zvbg0": "Vælg din leveringsmetode",
      "64tve23zvf80": "Du har 10 dage til at sende din telefon.",
      "64tve23zvjc0": "Hent en gratis forsendelsesetiket og send din telefon",
      "64tve23zvms0": "Modtag forsendelsesetiketten på din e-mail",
      "64tve23zvqg0": "Bemærk:",
      "64tve23zvyo0": "På grund af forsendelsesrestriktioner for litiumbatterier må du ikke sende telefonen, hvis du har mistanke om fejl i batteriet.",
      "64tve23zwak0": "Vi kan ikke returnere tilbehør eller emballage, der sendes med enheden.",
      "64tve23zwgs0": "Næste trin for at sælge din telefon",
      "64tve23zwm80": "Udfyld dine kontaktoplysninger",
      "64tve23zwt00": "Forbered din telefon til forsendelse",
      "64tve23zwwk0": "Din enhed bliver kontrolleret ved ankomst. Hvis oplysningerne ikke stemmer, sender vi et nyt tilbud. Du kan acceptere det eller få din enhed retur gratis."
    }
  },
  "PCPropertyList": {
    "index": {
      "646ynp3udds0": "购买渠道",
      "646ynp3ueas0": "需要激活，无法正常通话",
      "646ynp3uehw0": "Indtast IMEI-nummeret",
      "646ynp3uem40": "Tast *#06# på tastaturet for at se telefonens IMEI"
    }
  },
  "PCButton": {
    "index": {
      "646zhxujd5g0": "Se tilbuddet"
    }
  },
  "PCBottomButton": {
    "index": {
      "647hqss75ac0": "Påmindelse: Prisen kan falde med op til 6 %, så send din pakke hurtigst muligt.",
      "647hqss760c0": "Jeg har læst og accepterer",
      "647hqss764w0": "Privatlivspolitik",
      "647hqss76ac0": "Vilkår og betingelser",
      "647hqss76dg0": "Indsend",
      "647hqss76gw0": "I alt",
      "text1": "I alt",
      "text2": "Anslået pris",
      "text3": "Anslået bonus",
      "dialogTitle": "Bemærkning",
      "dialogText": "Klik på BEKRÆFT for at fortsætte og tjek din e-mail.",
      "dialogBtn": "BEKRÆFT"
    }
  },
  "PCUserInfo": {
    "index": {
      "647kboa03ks0": "Ordreoplysninger",
      "647kboa06ys0": "Navn",
      "647kboa0d6v8": "Landekode",
      "647kboa078s0": "Tlf.",
      "647kboa07d00": "Adresse",
      "647kboa07jk0": "Land",
      "647kboa07p80": "Vælg venligst",
      "647kboa08b40": "Postnummer",
      "647kboa08h00": "By",
      "647kboa08zc0": "Adresse",
      "647kboa09440": "Bankoplysninger",
      "647kboa096w0": "E-mailbekræftelse",
      "647kboa09ao0": "Email",
      "647kboa09dk0": "Bekræftelseskode",
      "647kboa09u40": "Indtast",
      "647kboa09z80": "Send",
      "647kboa0ak00": "Ugyldigt e-mailformat",
      "647kboa0aog0": "Sendt med succes",
      "send": "Sendt",
      "submit": "Indsend",
      "error": "Fejl i bekræftelseskode",
      "64jjt96fg400": "Indtast venligst bekræftelseskoden",
      "64jjt96fki00": "Hent venligst koden igen",
      "idNumber": "ID-nummer / Identitetskortnummer",
      "declaration": "Integritetserklæring",
      "download": "download",
      "647kboa0idc0": "Personligt ID",
      "647kboa0idc1": "(det officielle identifikationsnummer, der udstedes af dit land og bruges til juridiske, skattemæssige eller administrative formål. Dette kan være dit DNI, NIE, Skattenummer, Personnummer, CNP eller et tilsvarende nationalt dokument, afhængigt af hvor du bor.)",
      "647kboa0idc2": "(det officielle identifikationsnummer, der udstedes af dit land og bruges til juridiske, skattemæssige eller administrative formål. Dette kan være dit DNI, NIE, Skattenummer, Personnummer, CNP eller et tilsvarende nationalt dokument, afhængigt af hvor du bor.)",
      "idError": "Ugyldigt ID-nummer",
      "ibanTip": "Bruges til at modtage betalingen for den gamle enhed.",
      "addreddPlaceholder": "Dette felt understøtter op til 105 tegn"
    }
  },
  "successOrder": {
    "successOrder": {
      "647s39cv77s0": "Hjemmeside",
      "notRecyclable": "Denne type enhed kan ikke genanvendes",
      "IKnow": "Jeg forstår",
      "tips": "Tips"
    }
  },

  "blog": {
    "blogList": {
      "64wgr171lsk0": "Visninger",
      "64wgr171nq40": "Intet relateret indhold tilgængeligt.",
      "64wgr171av65": "Dato"
    },
    "blogDetail": {
      "64wgr9y5r7s0": "Visninger",
      "64wgr171wdx9": "Detaljer"
    }
  },

  "cookieNotice": {
    "title": "Cookie-meddelelse",
    "description": "Vi bruger cookies for at forbedre din oplevelse. Ved at fortsætte accepterer du vores",
    "cookiePolicy": "cookiepolitik",
    "acceptAll": "Accepter alle cookies",
    "acceptNecessary": "Accepter kun nødvendige cookies",
    "customize": {
      "title": "Vælg venligst de typer cookies, du vil acceptere:",
      "necessary": {
        "label": "Nødvendige cookies",
        "description": "Disse cookies er nødvendige for, at hjemmesiden fungerer, og kan ikke deaktiveres."
      },
      "analytics": {
        "label": "Analyse-cookies",
        "description": "Disse cookies hjælper os med at forstå, hvordan besøgende interagerer med vores hjemmeside."
      },
      "marketing": {
        "label": "Markedsføringscookies",
        "description": "Disse cookies sporer brugeraktivitet på tværs af websites for at vise relevante annoncer."
      }
    },
    "save": "Gem indstillinger",
    "cancel": "Annuller"
  }
}